<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">ACKNOWLEDGEMENTS</h2>
<p class="noindent"><span class="dropcap">I</span> am grateful to Pat Garland (whose collection is now held by Roger Carpenter), Alan Wild, Garth Tilt, Jeff Stone, Peter Jones and Mike Esau for steam age illustrations and to Stuart Warr for his modern colour photographs in various locations covered by this book. As usual, I have used the excellent layout details provided in the R.A. Cooke Layout series. I am also grateful to Tony Elliot, Richard Woodley and Richard Maund for their help with Irish and Trans-Atlantic boat services at Fishguard.</p>
<p class="indent">I have made every effort to identify all the copyright holders of pictorial and archive material used in this book. If I have wrongly attributed any material used, please email me at <span class="weblink"><a href="mailto:john_hodge@tiscali.co.uk"><span class="underline">john_hodge@tiscali.co.uk</span></a></span> if there is need to rectify the position.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Ack.vue?7c859b04